import { getContentListServerSideProps } from '../../lib/content-list-retriever'
import { SeriesLandingScreen } from 'app/features/series-landing/screen'
import { GetServerSideProps } from 'next'
import { withAuthedPage } from '../../lib/session'
import { verifyUser } from 'lib/verify-user'

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const store = context.req?.userStore
    const redirect = verifyUser(store)
    if (redirect) return redirect

    return await getContentListServerSideProps('Collection')(context)
  },
)

export default function CollectionPage() {
  return <SeriesLandingScreen type="Collection" />
}
